import cn from 'classnames';
import parse from 'html-react-parser';
import { useTranslation } from 'next-i18next/pages';
import dynamic from 'next/dynamic';
import React, { FC } from 'react';

import { LayoutAssets } from '@/shared/components/LayoutData';

import { BrandLogo } from './BrandLogo';
import headerStyle from './Header.module.scss';
import style from './PartnershipHeader.module.scss';

const SignupButton = dynamic(() => import('./SignupButton'), {
  ssr: false,
});

interface Props {
  partnershipLogo?: string;
  stickyHeader?: boolean;
  assetsData?: LayoutAssets;
}

function getAuthenticatePopup(assetsData?: LayoutAssets) {
  if (!assetsData) return null;
  const header = parse(assetsData.header);
  if (!Array.isArray(header)) return null;
  const signinPopup = header.find((item) => item.props?.id === 'sbr');
  if (!signinPopup) return null;
  return React.cloneElement(signinPopup, { suppressHydrationWarning: true });
}

const PartnershipLogo: FC<{ partnershipLogo?: string }> = ({
  partnershipLogo,
}) => {
  if (!partnershipLogo) return null;
  return (
    <div
      data-testid="partnership-logo"
      className={cn(style.brand, 'tw:flex', 'tw:items-center')}
    >
      <img src={partnershipLogo} alt="Partnership Logo" />
    </div>
  );
};

export const PartnershipHeader: FC<Props> = ({
  assetsData,
  partnershipLogo,
  stickyHeader,
}) => {
  const { i18n } = useTranslation();
  return (
    <header
      className={cn('c-header', 'p-header', {
        [style.partnership]: partnershipLogo,
      })}
      data-testid="partnership-header"
    >
      <div
        className={cn(
          'c-header__main',
          'sticky-shown',
          'with-transition',
          'sticky',
          {
            [headerStyle['always-shown']]: stickyHeader,
          }
        )}
      >
        <div className="c-header__wrapper u-wrapper">
          <div className="tw:flex">
            <div className="c-header__logo">
              <BrandLogo href={`/${i18n.language}`} />
            </div>
            <PartnershipLogo partnershipLogo={partnershipLogo} />
          </div>

          <div className="tw:flex-1" />

          <SignupButton />
        </div>
      </div>
      {getAuthenticatePopup(assetsData)}
    </header>
  );
};
